/**
 * Mobile device detection utilities
 * Provides reliable mobile detection for autoplay handling
 */

export const isMobileDevice = () => {
  // Check user agent for mobile indicators
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // Mobile patterns
  const mobilePatterns = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
    /Mobile/i
  ];
  
  const isUserAgentMobile = mobilePatterns.some(pattern => pattern.test(userAgent));
  
  // Touch capability check
  const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
  // Screen size check (fallback)
  const isSmallScreen = window.innerWidth <= 768;
  
  // Combine checks - prefer user agent but use touch/screen as fallback
  return isUserAgentMobile || (hasTouchScreen && isSmallScreen);
};

export const isIOS = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
};

export const isAndroid = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /Android/i.test(userAgent);
};

export const getMobileType = () => {
  if (isIOS()) return 'ios';
  if (isAndroid()) return 'android';
  if (isMobileDevice()) return 'mobile';
  return 'desktop';
};

// Debug info for troubleshooting
export const getDeviceInfo = () => {
  return {
    isMobile: isMobileDevice(),
    isIOS: isIOS(),
    isAndroid: isAndroid(),
    mobileType: getMobileType(),
    userAgent: navigator.userAgent,
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight,
    touchPoints: navigator.maxTouchPoints || 0,
    hasTouchScreen: 'ontouchstart' in window
  };
};